import defaultArchiveYears from '../resources/archiveYears.json';

const STORAGE_KEY = 'archiveYears.custom';

const normalizeYearValue = yearValue => String(yearValue || '').trim();

const sanitizeCustomArchiveYears = rawYears => {
  if (!Array.isArray(rawYears)) {
    return [];
  }

  return rawYears
    .map(year => normalizeYearValue(year && year.value))
    .filter(year => /^\d{4}$/.test(year))
    .filter((year, index, allYears) => allYears.indexOf(year) === index)
    .sort((firstYear, secondYear) => Number(secondYear) - Number(firstYear))
    .map((year, index) => ({
      id: 1000 + index,
      name: year,
      value: year
    }));
};

const readCustomArchiveYears = () => {
  try {
    const storedYears = localStorage.getItem(STORAGE_KEY);
    if (!storedYears) {
      return [];
    }

    return sanitizeCustomArchiveYears(JSON.parse(storedYears));
  } catch (error) {
    return [];
  }
};

const writeCustomArchiveYears = customYears => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(customYears));
  window.dispatchEvent(new Event('archive-years-updated'));
};

export const getArchiveYears = () => {
  const defaultYears = defaultArchiveYears.slice();
  const customYears = readCustomArchiveYears();
  const existingValues = defaultYears.map(year => normalizeYearValue(year.value));

  customYears.forEach(customYear => {
    if (!existingValues.includes(customYear.value)) {
      defaultYears.push(customYear);
    }
  });

  return defaultYears;
};

export const addCustomArchiveYear = yearValue => {
  const year = normalizeYearValue(yearValue);

  if (!/^\d{4}$/.test(year)) {
    return { success: false, reason: 'invalid' };
  }

  const existingYears = getArchiveYears().map(existingYear =>
    normalizeYearValue(existingYear.value)
  );

  if (existingYears.includes(year)) {
    return { success: false, reason: 'exists' };
  }

  const customYears = readCustomArchiveYears();
  const updatedCustomYears = sanitizeCustomArchiveYears([
    ...customYears,
    { value: year }
  ]);

  writeCustomArchiveYears(updatedCustomYears);
  return { success: true };
};

export const removeCustomArchiveYear = yearValue => {
  const year = normalizeYearValue(yearValue);
  const defaultValues = defaultArchiveYears.map(defaultYear =>
    normalizeYearValue(defaultYear.value)
  );

  if (defaultValues.includes(year)) {
    return { success: false, reason: 'default' };
  }

  const customYears = readCustomArchiveYears();
  const updatedCustomYears = sanitizeCustomArchiveYears(
    customYears.filter(customYear => normalizeYearValue(customYear.value) !== year)
  );

  writeCustomArchiveYears(updatedCustomYears);
  return { success: true };
};
